<div class="hover-expandable-cards">
  @for (card of cards(); track i; let i = $index; let first = $first; let last = $last) {
    <div
      class="hover-expandable-card"
      [class.active]="activeIndex() === i"
      [class.hover-expandable-card--left]="first"
      [class.hover-expandable-card--right]="last"
      (mouseenter)="onCardHover(i)"
    >
      <app-video-player
        [autoplay]="activeIndex() === i"
        [videoSrc]="card.video"
        [poster]="card.poster"
      />

      <div class="hover-expandable-card__gradient"></div>

      <div class="hover-expandable-card__content">
        <p class="hover-expandable-card__title type-title-h8">{{ card.title }}</p>
        <p class="hover-expandable-card__body type-body-b3">{{ card.description }}</p>
      </div>
    </div>
  }
</div>
